
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well-known/saml-configuration",
      function () {
        return require("private-next-pages/well-known/saml-configuration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well-known/saml-configuration"])
      });
    }
  